import InputFile, { UploadFileProps } from '@anm/components/InputFile';
import Loader from '@anm/components/Loader';
import React, { FC } from 'react';

import { HoverOverlay, Label, PreviewImage, UploadImageButton, Wrapper } from './Wrapper';

const DEFAULT_EXTENSIONS = ['jpg', 'jpeg', 'png'];

const allowedExtensionsList = DEFAULT_EXTENSIONS.map(e => `.${e}`).join();

type UploadImageWithPreviewProps = {
  onImageUpload: (props: UploadFileProps[]) => void;
  title?: string;
  isPending?: boolean;
  previewSrc?: string;
  uploadButtonTitle?: string;
  extensionsList?: string;
};

const UploadImageWithPreview: FC<UploadImageWithPreviewProps> = ({
  title,
  previewSrc,
  isPending = false,
  extensionsList = allowedExtensionsList,
  uploadButtonTitle = 'Thumbnail',
  onImageUpload
}) => (
  <Label>
    {(isPending || previewSrc) && (
      <HoverOverlay previewSrc={!!previewSrc} {...{ isPending }}>
        {isPending ? <Loader size="small" color="black" /> : 'Replace'}
      </HoverOverlay>
    )}
    <InputFile accept={extensionsList} handleUpload={onImageUpload} disabled={isPending} />
    <Wrapper>
      {previewSrc ? (
        <PreviewImage src={previewSrc} alt={title} />
      ) : (
        <UploadImageButton icon="images/streaming/upload.svg" size="small" variant="simple">
          {uploadButtonTitle}
        </UploadImageButton>
      )}
    </Wrapper>
  </Label>
);

export default UploadImageWithPreview;
